import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { PageWrapper } from 'virtues-bootstrap';
import ReactRouterPropTypes from 'react-router-prop-types';
import EditPatientInformation from 'containers/EditPatientsInformation/EditPatientInformation';
import ResetPatientsPassword from 'containers/EditPatientsInformation/ResetPatientsPassword';
import PageLoader from 'components/PageLoading';

const PatientEngagementIndex = ({ loading, getData, isData, match }) => {
  useEffect(() => {
    if (!loading) {
      getData();
    }
  }, [getData, loading]);

  if (loading || !isData) {
    return <PageLoader />;
  }

  return (
    <PageWrapper tight>
      <EditPatientInformation patientId={match.params.id} />
      <ResetPatientsPassword patientId={match.params.id} />
    </PageWrapper>
  );
};

PatientEngagementIndex.propTypes = {
  match: ReactRouterPropTypes.match.isRequired,
  getData: PropTypes.func.isRequired,
  loading: PropTypes.bool.isRequired,
  isData: PropTypes.bool.isRequired,
};

export default PatientEngagementIndex;
